import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGridContainer = styled(Grid)`
  border: 2px solid #eeeeee;
  border-radius: 5px;
  padding: 15px 15px 10px 10px;
  padding-top: 5px;
`;

export const StyledBox = styled(Box)`
  width: 100%;
  max-width: 745px;
`;

export const StyledModalBox = styled(Box)`
  position: absolute;
  padding: 5px;
  width: 450px;
  background-color: white;
  border-radius: 1ch;
  box-shadow: 0 0 10px 5px #363636;
`;

export const ModalContent = styled(Box)`
  padding: 2ch;
  text-align: center;
`;

export const ModalFooter = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 5px;
  padding: 10px;
`;